module.exports = __webpack_public_path__ + "img/Group 4@2x3.9c5f14fe.png";